import { jsx, jsxs } from "react/jsx-runtime";
import { Avatar, Dropdown } from "antd";
import { useAppStore } from "@spiral-app/core";
import { UserOutlined } from "@ant-design/icons";
import { getT } from "../../_utils/intl";
import useTiMaxStore from "../../hooks/useTiMaxStore";
import useLoginInfo from "../../hooks/useLoginInfo";
import useStyles from "./style";
const UserInfo = ({ onEditPassword, onLogout }) => {
  const t = getT();
  const { styles } = useStyles();
  const { clearData } = useAppStore();
  const { resetLoginInfo } = useTiMaxStore();
  const { userInfo } = useLoginInfo();
  const items = [
    {
      key: "3",
      label: t("login.btn.edit_password"),
      onClick: () => {
        onEditPassword == null ? void 0 : onEditPassword();
      }
    },
    {
      key: "1",
      label: t("login.btn.logout"),
      onClick: () => {
        clearData();
        resetLoginInfo();
        onLogout == null ? void 0 : onLogout();
      }
    }
  ];
  return /* @__PURE__ */ jsx(Dropdown, { menu: { items }, children: /* @__PURE__ */ jsxs("div", { className: styles.btn, children: [
    /* @__PURE__ */ jsx(Avatar, { icon: /* @__PURE__ */ jsx(UserOutlined, {}) }),
    /* @__PURE__ */ jsx("div", { children: userInfo.userName })
  ] }) });
};
var UserInfo_default = UserInfo;
export {
  UserInfo_default as default
};
